import { observable } from 'mobx';
import useMount from '../../utils/hooks/use-mount';
import debounce from 'lodash.debounce';

class SceneStore {
  @observable isComplete;

  //画布宽度
  @observable width;

  //画布高度
  @observable height;

  onComplete = value => {
    this.isComplete = value;
  };

  constructor({ ...rest } = {}) {
    Object.assign(this, rest);
  }

  use() {
    useMount(() => {
      this.width = window.innerWidth;
      this.height = window.innerHeight;
      window.addEventListener(
        'resize',
        debounce(() => {
          this.width = window.innerWidth;
          this.height = window.innerHeight;
        }, 500)
      );
    });
  }
}
export default SceneStore;
